import React from 'react';

interface Props {
  title: string;
  description?: string;
  value: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
}

export function ToggleRow({ title, description, value, onChange, disabled }: Props) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={value}
      disabled={disabled}
      onClick={() => onChange(!value)}
      className={[
        'flex gap-2.5 items-center w-full text-left px-3.5 py-3 border-t border-ink-100',
        'bg-transparent btn-focus transition-colors hover:bg-ink-100/40',
        disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer',
      ].join(' ')}
    >
      <span className="flex-1 min-w-0">
        <span className="block font-display font-bold text-[13px] text-ink-900 mb-0.5">{title}</span>
        {description && (
          <span className="block text-[11px] text-ink-500 leading-snug">{description}</span>
        )}
      </span>
      <span
        className={[
          'relative inline-block w-9 h-5 rounded-full shrink-0 transition-colors',
          value ? 'bg-green-700' : 'bg-ink-300',
        ].join(' ')}
      >
        <span
          className={[
            'absolute top-0.5 w-4 h-4 rounded-full bg-white shadow transition-all',
            value ? 'left-[18px]' : 'left-0.5',
          ].join(' ')}
        />
      </span>
    </button>
  );
}
